// extracted by mini-css-extract-plugin
export default {"button":"vq-z","reviewSort":"wq-z"};